import axios from 'axios'

export default {
  sendInvitationsStudents(students) {
    return axios.post('/api/admins/inviting', students)
  },
  sendInvitationsOtherUsers(users) {
    return axios.post('/api/users/', users)
  }
}
